import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  accTechRadarClientRef,
  TechRadarClient,
} from './api/tech-radar-client';

export const accTechradarPlugin = createPlugin({
  id: 'acc-techradar',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: accTechRadarClientRef,
      deps: {
        config: configApiRef,
        identity: identityApiRef,
      },
      factory({ config, identity }): TechRadarClient {
        return new TechRadarClient(config, identity);
      },
    }),
  ],
});

export const AccTechradarPage = accTechradarPlugin.provide(
  createRoutableExtension({
    name: 'AccTechradarPage',
    component: () => import('./components/RadarIndex').then(m => m.RadarIndex),
    mountPoint: rootRouteRef,
  }),
);
